import React from 'react'
import {IndexRoute} from 'react-router'
import {TRouteShowPage} from '../TRouteShowPage'

export const routes = (
  <IndexRoute component={TRouteShowPage} />
)
